export default __webpack_public_path__ + "static/media/helmet1.08f1d4da.webp";